// extracted by mini-css-extract-plugin
export default {"header":"header-Ba8yV","actions":"actions-gnOCp","actionsContent":"actionsContent-J4XK3","readonly":"readonly-MMY69"};